import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ComposeIcon } from '@app/modules/compose/components/ComposeIcon';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { BreadcrumbItem } from '@mi-front/ui';
import { defineMessage, useIntl } from 'react-intl';
import { ComposeCreateForm } from './ComposeCreateForm';

const composeCreatePageTitleMessage = defineMessage({
  id: 'compose.createPage.title',
  defaultMessage: 'Crear composición',
});

const composeListHubLabelMessage = defineMessage({
  id: 'compose.listScreen.hubLabel',
  defaultMessage: 'Compose',
});

/**
 * Full-page form to create a composition for the station resolved by the route.
 */
export function ComposeCreatePage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  const title = $t(composeCreatePageTitleMessage);
  const listPath = composeRouteGenerator.listForStationSlug(station.slug);

  const breadcrumbItems: readonly BreadcrumbItem[] = [
    {
      icon: <ComposeIcon fontSize="inherit" />,
      content: $t(composeListHubLabelMessage),
      href: listPath,
    },
    {
      content: station.name,
      href: listPath,
    },
    {
      content: title,
      active: true,
    },
  ];

  return (
    <Page htmlTitle={`${title} | ${station.name}`}>
      <Page.Header
        icon={<ComposeIcon />}
        title={title}
        backBtn={listPath}
        breadcrumbs={<Page.Breadcrumbs items={breadcrumbItems} />}
      />
      <Page.Content>
        <ComposeCreateForm station={station} />
      </Page.Content>
    </Page>
  );
}
